import { Box, Stack, Tooltip } from '@mui/material';
import { SxProps, Theme, styled } from '@mui/material/styles';
import { fileData, fileFormat, fileThumb } from './utils';

type FileIconProps = {
  file: File | string;
  tooltip?: boolean;
  imageView?: boolean;
  sx?: SxProps<Theme>;
  imgSx?: SxProps<Theme>;
};

const FileCard = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: 'inherit',
  height: 'inherit',
}));

const ImageWrapper = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  flexShrink: 0,
  objectFit: 'cover',
}));

const ThumbnailImage = styled('img')(({ theme }) => ({
  width: 32,
  height: 32,
  flexShrink: 0,
}));

const CenteredStack = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: 'inherit',
  height: 'inherit',
}));

export default function FileThumbnail({
  file,
  tooltip,
  imageView,
  sx,
  imgSx,
}: FileIconProps) {
  const { name = '', path = '', preview = '', mimeType } = fileData(file);
  const format = fileFormat(name || path || preview);
  const isImage = format === 'image' || mimeType?.split('/')[0] === 'image';

  const renderContent =
    isImage && imageView ? (
      <ImageWrapper src={preview} sx={imgSx} className={'preview'} />
    ) : (
      <ThumbnailImage src={fileThumb(format)} sx={imgSx} />
    );

  if (tooltip) {
    return (
      <Tooltip title={name}>
        <CenteredStack>{renderContent}</CenteredStack>
      </Tooltip>
    );
  }

  return <FileCard sx={sx}>{renderContent}</FileCard>;
}
